module.exports = __webpack_public_path__ + "img/img_display_2.78e78678.svg";